/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Approval_Not_Set_LabelInputs */

const en_style_guide_manager_approval_not_set_label = /** @type {(inputs: Style_Guide_Manager_Approval_Not_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval Not Set`)
};

const fr_style_guide_manager_approval_not_set_label = /** @type {(inputs: Style_Guide_Manager_Approval_Not_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approbation non definie`)
};

const de_style_guide_manager_approval_not_set_label = /** @type {(inputs: Style_Guide_Manager_Approval_Not_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigung nicht festgelegt`)
};

const it_style_guide_manager_approval_not_set_label = /** @type {(inputs: Style_Guide_Manager_Approval_Not_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvazione non impostata`)
};

const ru_style_guide_manager_approval_not_set_label = /** @type {(inputs: Style_Guide_Manager_Approval_Not_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Утверждение не установлено`)
};

const es_style_guide_manager_approval_not_set_label = /** @type {(inputs: Style_Guide_Manager_Approval_Not_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobación no establecida`)
};

const zh_cn2_style_guide_manager_approval_not_set_label = /** @type {(inputs: Style_Guide_Manager_Approval_Not_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审批未设置`)
};

const ja_style_guide_manager_approval_not_set_label = /** @type {(inputs: Style_Guide_Manager_Approval_Not_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認が設定されていません`)
};

const hi_style_guide_manager_approval_not_set_label = /** @type {(inputs: Style_Guide_Manager_Approval_Not_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमोदन अभी तक निर्धारित नहीं किया गया है`)
};

const pt_pt2_style_guide_manager_approval_not_set_label = /** @type {(inputs: Style_Guide_Manager_Approval_Not_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovação não definida`)
};

/**
* | output |
* | --- |
* | "Approval Not Set" |
*
* @param {Style_Guide_Manager_Approval_Not_Set_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_approval_not_set_label = /** @type {((inputs?: Style_Guide_Manager_Approval_Not_Set_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Approval_Not_Set_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_approval_not_set_label(inputs)
	if (locale === "de") return de_style_guide_manager_approval_not_set_label(inputs)
	if (locale === "it") return it_style_guide_manager_approval_not_set_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_approval_not_set_label(inputs)
	if (locale === "es") return es_style_guide_manager_approval_not_set_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_approval_not_set_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_approval_not_set_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_approval_not_set_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_approval_not_set_label(inputs)
	return en_style_guide_manager_approval_not_set_label(inputs)
});